import { getHeaders } from "../utils/getHeaders";

interface SavedSearchIds {
  savedSearchIds: string[];
}
const deleteSavedSearches = async (
  url: string | URL,
  ids: SavedSearchIds,
  authToken: string,
  isToUseAuthZero: boolean
): Promise<boolean> => {
  const headers = getHeaders(authToken, isToUseAuthZero);
  const deleteUrl = url instanceof URL ? url.href : url;

  const res = await fetch(deleteUrl, {
    method: "DELETE",
    headers,
    body: JSON.stringify(ids),
  });

  if (!res.ok) {
    throw new Error(
      `An error (${res.status}) occurred while deleting the data.`
    );
  }

  return true;
};

export default deleteSavedSearches;
